<script>
	const icons = import.meta.glob('../../assets/svg/icons/*.svg', {
		query: '?raw',
		import: 'default',
		eager: true
	});

	/**
	 * @param {string} name
	 */
	function rawSVG(name) {
		return icons[`../../assets/svg/icons/${name}.svg`];
	}
	const notFound = '‽';

	export let fill = false;
	/** @type {string} */
	export let name;
</script>

<div class="icon" class:fill data-testid="icon" on:click on:keydown role="none">
	{@html rawSVG(name) || notFound}
</div>

<style>.icon{display:contents;font-size:1.5rem;font-size:var(--size, 1.5rem)}.icon :global(svg){height:1em;width:1em}.icon:not(.fill) :global(svg circle),.icon:not(.fill) :global(svg path),.icon:not(.fill) :global(svg rect){stroke:currentcolor;stroke:var(--stroke, currentcolor);stroke-width:1.75;stroke-width:var(--stroke-width, 1.75)}.icon :global(svg.fill path):not(.no-fill),.icon.fill :global(svg circle):not(.no-fill),.icon.fill :global(svg path):not(.no-fill),.icon.fill :global(svg rect):not(.no-fill){stroke:none;stroke:var(--stroke, none);fill:currentcolor;fill:var(--fill, currentcolor)}</style>
